module.exports = __webpack_public_path__ + "static/img/pico412.c0b0c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico412.png
// module id = uQxy
// module chunks = 0